<template>
  <div class="container mt-5">
    <div class="row mb-5">
      <div class="col-8">
        <h3>Edit team</h3>
      </div>
      <div class="col-4 text-right">
        <button @click="$router.go(-1)" type="button" class="btn btn-secondary">Back</button>
      </div>
    </div>
    <div class="row" v-if="team">
      <div class="col-8 offset-2">
        <form @submit="submit">
          <div class="form-group">
            <label for="name">Team Name *</label>
            <input type="text" name="name" id="name" class="form-control" placeholder="ex: My Team" required v-model="form.name">
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="teamcompetitions">Team Competitions <small><i class="text-muted">Optional</i></small></label>
                <v-select v-model="form.teamcompetitions" :options="competitions" multiple></v-select>
              </div>
            </div>
          </div>
          <hr>
          <label class="text-muted small">Team Competitions Overrides (JSON)</label>
          <div class="form-group" v-for="teamcompetition of form.teamcompetitions" :key="teamcompetition._id">
            <label>{{ teamcompetition.label }}</label>
            <editor v-model="teamcompetition.overrides" @init="editorInit" lang="json" theme="chrome" height="100"></editor>
          </div>
          <hr>
          <button type="submit" class="btn btn-primary btn-lg">Save</button>
        </form>
      </div>
    </div>
    <Loading v-if="!team"/>
  </div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { competitionService } from '../../services/competition'
import { teamService } from '../../services/team'
import vSelect from 'vue-select'

export default {
  name: 'TeamEdit',
  components: { datePicker, vSelect, editor: require('vue2-ace-editor') },
  data () {
    return {
      date: new Date(),
      options: {
        format: 'YY-MM-DD HH:mm',
        useCurrent: false
      },
      competitions: [],
      form: {
        name: '', teamcompetitions: null
      },
      team: null,
      selected: null
    }
  },
  mounted () {
    competitionService.getAll().then(result => {
      for (let competition of result.data.competitions) {
        this.competitions.push({label: competition.name, value: competition._id, overrides: '{}'})
      }
      teamService.getOne(this.$route.params.id).then(result => {
        this.team = result.data.team
        this.form.name = this.team.name
        this.form.teamcompetitions = []
        for (let tc of this.team.teamCompetitions) {
          const filter = this.competitions.filter(competition => competition.value === tc.competition)
          if (filter[0]) {
            let label = filter[0].label
            this.form.teamcompetitions.push({ label, value: tc.competition, overrides: JSON.stringify(tc.overrides, null, '\t') })
          }
        }
      })
    })
  },
  methods: {
    submit (ev) {
      ev.preventDefault()

      teamService.updateOne({name: this.form.name, _id: this.team._id}).then(teamRes => {
        teamService.unlinkTeamAndCompetitions(this.team.teamCompetitions.map(tc => tc._id)).then(utcRes => {
          teamService.linkTeamAndCompetitions(teamRes._id, this.form.teamcompetitions.map(tc => { return { _id: tc.value, overrides: tc.overrides } })).then(tcRes => {
            this.$router.push({ name: 'TeamShow', params: { id: teamRes._id } })
          })
        })
      })
    },
    editorInit: function () {
      require('brace/ext/language_tools')
      require('brace/mode/html')
      require('brace/mode/json')
      require('brace/mode/less')
      require('brace/theme/chrome')
      require('brace/snippets/json')
    }
  }
}
</script>
<style lang="scss">
div.dropdown-toggle::after{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/Teams/TeamEdit.vue